
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pt-28 pb-16">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <div className="mb-4 flex justify-center">
              <FileText className="h-12 w-12 text-apple-blue" />
            </div>
            <h1 className="text-4xl font-bold text-apple-text mb-4">
              Terms of Service
            </h1>
            <p className="text-xl text-apple-text-secondary max-w-3xl mx-auto">
              Last updated: {new Date().toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'})}
            </p>
          </div>

          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8 mb-12">
            <div className="prose prose-apple mx-auto">
              <h2>1. Agreement to Terms</h2>
              <p>
                These Terms of Service constitute a legally binding agreement made between you and True Talent Apply ("we," "us," or "our"), concerning your access to and use of our website and services.
              </p>
              <p>
                By accessing or using our platform, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not access the service.
              </p>

              <h2>2. Description of Service</h2>
              <p>
                True Talent Apply is a recruitment platform that connects job seekers with employers through AI-powered assessments and video interviews. Our services include job listings, application processing, skills assessments, video introductions, and candidate-employer matching.
              </p>

              <h2>3. User Accounts</h2>
              <p>
                When you create an account with us, you must provide accurate, complete, and current information. You are responsible for safeguarding the password and for all activities that occur under your account.
              </p>
              <p>
                You agree to notify us immediately of any unauthorized use of your account or any other breach of security. We cannot and will not be liable for any loss or damage arising from your failure to comply with this section.
              </p>

              <h2>4. User Conduct</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use our platform for any illegal purpose or in violation of any local, state, national, or international law</li>
                <li>Violate or infringe other people's intellectual property, privacy, publicity, or other legal rights</li>
                <li>Impersonate any person or entity or falsely state or misrepresent your affiliation with a person or entity</li>
                <li>Interfere with or disrupt the operation of our platform</li>
                <li>Transmit any viruses, malware, or other harmful code</li>
                <li>Attempt to gain unauthorized access to our systems or user accounts</li>
                <li>Collect or store personal data about other users without their consent</li>
                <li>Post content that is threatening, abusive, defamatory, obscene, or otherwise objectionable</li>
              </ul>

              <h2>5. Intellectual Property</h2>
              <p>
                Our platform and its original content, features, and functionality are owned by True Talent Apply and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
              <p>
                By submitting content to our platform, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, and distribute such content in connection with providing our services.
              </p>

              <h2>6. Payments</h2>
              <p>
                Certain features of our platform may require payment. All payments are processed securely through our payment providers. By providing payment information, you represent that you are authorized to use the payment method.
              </p>
              <p>
                Fees are non-refundable except as required by law or as explicitly stated in our refund policy.
              </p>

              <h2>7. Termination</h2>
              <p>
                We may terminate or suspend your account and access to our services immediately, without prior notice or liability, for any reason, including if you breach these Terms.
              </p>
              <p>
                Upon termination, your right to use the service will immediately cease. All provisions of these Terms which by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
              </p>

              <h2>8. Disclaimer of Warranties</h2>
              <p>
                Our platform is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the platform will be uninterrupted, secure, or error-free.
              </p>

              <h2>9. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, in no event shall True Talent Apply be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly.
              </p>

              <h2>10. Indemnification</h2>
              <p>
                You agree to defend, indemnify, and hold harmless True Talent Apply and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including legal fees, arising out of or in any way connected with your access to or use of our services or your violation of these Terms.
              </p>

              <h2>11. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.
              </p>

              <h2>12. Changes to Terms</h2>
              <p>
                We reserve the right to modify or replace these Terms at any time. It is your responsibility to review these Terms periodically for changes.
              </p>

              <h2>13. Contact Us</h2>
              <p>
                If you have any questions about these Terms, please contact us.
              </p>
              <div className="mt-6 text-center">
                <Button asChild className="bg-apple-blue hover:bg-apple-blue/90">
                  <Link to="/contact">Contact Us</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
